// extracted by mini-css-extract-plugin
export default {"container":"sqior-page_container__Lj+eJ","header":"sqior-page_header__nDMPb","btn-balancer":"sqior-page_btn-balancer__0Stjy","logo":"sqior-page_logo__d6fIP"};